
import { OTable } from '@oruga-ui/oruga'

export default {
  extends: OTable,
}
